<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color} stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M12.3266 11.9956L17.7778 17.3786L17.1485 18L11.0768 12.0044L17.1485 6L17.7778 6.62144L12.3266 12.0044V11.9956ZM13.4789 6.62144L12.8495 6L6.77783 11.9956L12.8495 17.9912L13.4789 17.3698L8.02763 11.9956L13.4789 6.62144Z"
      :class="colorClass"
      stroke-width="0.5"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
